/**
 * @generated SignedSource<<501d64eb6549c0fa3afccb0cda472e96>>
 * @relayHash 4bdedd6d9bf72bbdf061149dd7f2fb0f
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 4bdedd6d9bf72bbdf061149dd7f2fb0f

import { ConcreteRequest } from 'relay-runtime';
export type VerifyMedicationStatus = "NONE" | "NOT_ENQUIRED" | "SOME";
export type deVerifyMedicationQuery$variables = {
  appointmentId: string;
  patientId: string;
  skip: boolean;
};
export type deVerifyMedicationQuery$data = {
  readonly medicationVerification?: {
    readonly result?: {
      readonly currentAppointmentId: string;
      readonly isVerified: boolean;
      readonly lastVerifiedAt: string | null;
      readonly lastVerifiedBy: string | null;
      readonly lastVerifyMedicationStatus: VerifyMedicationStatus | null;
      readonly patientId: string;
    };
  };
};
export type deVerifyMedicationQuery = {
  response: deVerifyMedicationQuery$data;
  variables: deVerifyMedicationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "appointmentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "patientId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "appointmentId",
    "variableName": "appointmentId"
  },
  {
    "kind": "Variable",
    "name": "patientId",
    "variableName": "patientId"
  }
],
v2 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MedicationVerificationOutput",
      "kind": "LinkedField",
      "name": "result",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isVerified",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "patientId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currentAppointmentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastVerifiedAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastVerifiedBy",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastVerifyMedicationStatus",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "de_SuccessMedicationVerificationResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deVerifyMedicationQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "medicationVerification",
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "de_medicationVerification",
            "plural": false,
            "selections": [
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "deVerifyMedicationQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": "medicationVerification",
            "args": (v1/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "de_medicationVerification",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "4bdedd6d9bf72bbdf061149dd7f2fb0f",
    "metadata": {},
    "name": "deVerifyMedicationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "8ffd45f8942e575fe2f0362d76551be6";

export default node;
